module.exports = __webpack_public_path__ + "static/media/phone.af1c1b12.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/assets/phone.svg
// module id = 598
// module chunks = 20